import { render, staticRenderFns } from "./th-ordering-button.vue?vue&type=template&id=ba7aab4e&scoped=true"
import script from "./th-ordering-button.vue?vue&type=script&lang=js"
export * from "./th-ordering-button.vue?vue&type=script&lang=js"
import style0 from "./th-ordering-button.vue?vue&type=style&index=0&id=ba7aab4e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7aab4e",
  null
  
)

export default component.exports